import React from 'react';
import Icon from '../../../components/AppIcon';

const CheckoutProgress = ({ currentStep = 1 }) => {
  const steps = [
    { id: 1, name: 'Shipping', icon: 'Truck' },
    { id: 2, name: 'Payment', icon: 'CreditCard' },
    { id: 3, name: 'Review', icon: 'Eye' },
    { id: 4, name: 'Confirmation', icon: 'CheckCircle' }
  ];

  return (
    <div className="w-full bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.id}>
            <div className="flex flex-col items-center">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${
                step?.id <= currentStep 
                  ? 'bg-primary border-primary text-white' :'bg-background border-border text-muted-foreground'
              }`}>
                <Icon name={step?.icon} size={20} />
              </div>
              <span className={`mt-2 text-sm font-medium ${
                step?.id <= currentStep ? 'text-foreground' : 'text-muted-foreground'
              }`}>
                {step?.name}
              </span>
            </div>
            {index < steps?.length - 1 && (
              <div className={`flex-1 h-0.5 mx-4 transition-all duration-300 ${
                step?.id < currentStep ? 'bg-primary' : 'bg-border'
              }`} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default CheckoutProgress;